var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0531311 7.46601C0.0531311 3.63279 3.25637 0.534546 7.131 0.534546C11.0166 0.534546 14.2198 3.63279 14.2198 7.46601C14.2198 9.39762 13.5173 11.1909 12.361 12.7109C11.0855 14.3875 9.51326 15.8483 7.74358 16.9949C7.33856 17.2599 6.97303 17.2799 6.52851 16.9949C4.74874 15.8483 3.17654 14.3875 1.91188 12.7109C0.754784 11.1909 0.0531311 9.39762 0.0531311 7.46601ZM4.79833 7.68184C4.79833 8.96597 5.84618 9.97594 7.13101 9.97594C8.41667 9.97594 9.47461 8.96597 9.47461 7.68184C9.47461 6.40771 8.41667 5.34857 7.13101 5.34857C5.84618 5.34857 4.79833 6.40771 4.79833 7.68184Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.893b909503097e0c830bccc401a453a9.svg";
export { ForwardRef as ReactComponent };